// YNX — CLIENTS MODULE (base de données clients)
import React, { useState, useEffect, useCallback } from 'react';
import { Plus, Trash2, X, Mail, Phone, Building2 } from 'lucide-react';
import { listClients, createClient, deleteClient } from '../../lib/biz';

export const ClientsModule = () => {
  const [items, setItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', phone: '', company: '', address: '', siret: '', vat_number: '', notes: '' });
  const [busy, setBusy] = useState(false);
  const [search, setSearch] = useState('');

  const refresh = useCallback(async () => {
    try { setItems(await listClients()); }
    catch (e) { console.warn('YNX clients: refresh failed', e); }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);

  const add = async () => {
    if (!form.name.trim()) return;
    setBusy(true);
    try {
      await createClient(form);
      setForm({ name: '', email: '', phone: '', company: '', address: '', siret: '', vat_number: '', notes: '' });
      setShowForm(false);
      await refresh();
    } finally { setBusy(false); }
  };

  const remove = async (id) => {
    if (!window.confirm('Supprimer ce client ?')) return;
    await deleteClient(id);
    await refresh();
  };

  const filtered = items.filter((c) => {
    const s = search.toLowerCase();
    return !s || c.name?.toLowerCase().includes(s) || c.email?.toLowerCase().includes(s) || c.company?.toLowerCase().includes(s);
  });

  return (
    <div className='biz-module'>
      <header className='biz-module-head'>
        <h2>👥 Clients</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <input
            className='biz-input'
            style={{ width: 220 }}
            name='cli-search'
            placeholder='Rechercher…'
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button className='biz-btn-primary sm' onClick={() => setShowForm(true)} data-testid='cli-add-btn'>
            <Plus size={14} /> Nouveau client
          </button>
        </div>
      </header>

      {filtered.length === 0 && <div className='biz-empty'>Aucun client. Ajoutez-en pour commencer.</div>}

      <div className='biz-grid-3'>
        {filtered.map((c) => (
          <article key={c.id} className='biz-card'>
            <header className='biz-card-head'>
              <div>
                <h4>{c.name}</h4>
                {c.company && <p className='biz-card-sub'><Building2 size={11} /> {c.company}</p>}
              </div>
              <button className='biz-icon-btn danger' onClick={() => remove(c.id)}><Trash2 size={12} /></button>
            </header>
            <div className='biz-card-body'>
              {c.email && <p><Mail size={11} /> <a href={`mailto:${c.email}`}>{c.email}</a></p>}
              {c.phone && <p><Phone size={11} /> <a href={`tel:${c.phone}`}>{c.phone}</a></p>}
              {c.address && <p style={{ opacity: 0.8 }}>{c.address}</p>}
              {c.siret && <p style={{ opacity: 0.7, fontSize: 11 }}>SIRET : {c.siret}</p>}
              {c.notes && <p style={{ marginTop: 8, fontStyle: 'italic', opacity: 0.85 }}>{c.notes}</p>}
            </div>
          </article>
        ))}
      </div>

      {showForm && (
        <div className='biz-modal-overlay' onClick={(e) => e.target === e.currentTarget && setShowForm(false)}>
          <div className='biz-modal'>
            <header className='biz-modal-head'><h3>Nouveau client</h3>
              <button className='biz-icon-btn' onClick={() => setShowForm(false)}><X size={14} /></button>
            </header>
            <div className='biz-modal-body'>
              <label className='biz-label'>Nom *</label>
              <input className='biz-input' name='cli-name' value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
              <label className='biz-label'>Entreprise</label>
              <input className='biz-input' name='cli-company' value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} />
              <label className='biz-label'>Email</label>
              <input className='biz-input' name='cli-email' type='email' value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
              <label className='biz-label'>Téléphone</label>
              <input className='biz-input' name='cli-phone' value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
              <label className='biz-label'>Adresse</label>
              <input className='biz-input' name='cli-address' value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} />
              <label className='biz-label'>SIRET</label>
              <input className='biz-input' name='cli-siret' value={form.siret} onChange={(e) => setForm({ ...form, siret: e.target.value })} />
              <label className='biz-label'>N° TVA intracom</label>
              <input className='biz-input' name='cli-vat' value={form.vat_number} onChange={(e) => setForm({ ...form, vat_number: e.target.value })} />
              <label className='biz-label'>Notes</label>
              <textarea className='biz-input' name='cli-notes' rows={3} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} />
            </div>
            <footer className='biz-modal-foot'>
              <button className='biz-btn-ghost' onClick={() => setShowForm(false)}>Annuler</button>
              <button className='biz-btn-primary' onClick={add} disabled={busy} data-testid='cli-save-btn'>
                {busy ? 'Enregistrement…' : 'Créer'}
              </button>
            </footer>
          </div>
        </div>
      )}
    </div>
  );
};
